export const DISPLAY_NONE = 'none';
export const DISPLAY_INLINE_BLOCK = 'inline-block';
export const LARGE_DESKTOP_BREAKPOINT = 1180;
export const DESKTOP_BREAKPOINT = 960;
export const TABLET_BREAKPOINT = 720;

export const PAGE_SIZE = 10;

export const TAB_HEADER_HEIGHT = 55;

export const MOBILE_HEADER_HEIGHT = 51;

export const DESKTOP_HEADER_HEIGHT = 136;

export const STICKED_PRODUCT_DESCRIPTION_HEIGHT = 64;

export const VALID_BIAS = 60;
